<template>
  <div>
    <div style="text-align:right">
      <a href="/#/appts/schedule"><i class="fa-solid fa-calendar"></i></a
      >&nbsp;&nbsp;
      <a href="/#/appts"><i class="fa-solid fa-list"></i></a>
    </div>
    <b-card body-class="p-0" header-class="border-0">
      <SeachResults :query="query" />
    </b-card>
  </div>
</template>

<script>
import SeachResults from "@/views/Components/Appt/SearchResults.vue";
export default {
  components: { SeachResults },
  data() {
    return {
      query: {
        sortOption: "Date:descending",
      },
    };
  },
};
</script>

<style></style>
